import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useAnalytics } from 'use-analytics';
import DateFilter from '../../../../Filters/DateSelectorFilter';
import { hotelSearch } from '../../../../../store/slices/hotel';
import { setHotelTripSearchInputs } from '../../../../../store/slices/tripSearch';
import { getTravelPolicyLeadDays } from '../../../../../store/slices/user';
import { TravelTypes } from '../../../../../constants';

const CheckInDateFilter = ({
  tripId, doOpenDatePicker, setDoOpenDatePicker, bgClassName,
}) => {
  const dispatch = useDispatch();
  const isHotelTripSearch = !tripId;
  const { track } = useAnalytics();

  const {
    searchObj = {},
    defaultSearchObj = {},
  } = useSelector((store) => store.hotel.hotelSearches[tripId] || {});

  const hotelTripSearchInputs = useSelector((store) => store.tripSearch.searchInputs.hotel);
  const leadDays = useSelector(getTravelPolicyLeadDays(TravelTypes.hotel));

  const value = isHotelTripSearch ? hotelTripSearchInputs.checkInDate : searchObj.checkInDate;
  let checkOutDate = isHotelTripSearch ? hotelTripSearchInputs.checkOutDate
    : searchObj.checkOutDate;
  const defaultValue = isHotelTripSearch ? hotelTripSearchInputs.checkInDate
    : defaultSearchObj.checkInDate;

  const handleChange = (newValue) => {
    if (newValue) {
      setDoOpenDatePicker(false);
    }
    if (!checkOutDate || dayjs(newValue).diff(checkOutDate, 'day') >= 0) {
      checkOutDate = dayjs(newValue).add(1, 'day').format('YYYY-MM-DD');
    }
    const payload = {
      tripId,
      searchObj: {
        page: 1,
        checkInDate: newValue,
        checkOutDate,
      },
    };
    if (isHotelTripSearch) {
      dispatch(setHotelTripSearchInputs({ ...payload.searchObj }));
    } else {
      dispatch(hotelSearch(payload));
    }
    track('hotelCheckInDate.handleChange', {
      checkInDate: newValue,
      checkOutDate,
    });
  };

  return (
    <DateFilter
      onChange={handleChange}
      label={value ? 'Check-in' : 'Check-in Date'}
      value={value}
      defaultValue={defaultValue}
      variant={isHotelTripSearch ? 'outline-no-radius' : 'outline'}
      filterButtonMaxWidth={clsx('max-w-full', { 'w-full': isHotelTripSearch })}
      doOpenDatePicker={doOpenDatePicker}
      setDoOpenDatePicker={setDoOpenDatePicker}
      bgClassName={!isHotelTripSearch ? '' : bgClassName}
      textColorClassName="text-datepicker-0"
      leadDays={leadDays}
    />
  );
};

CheckInDateFilter.propTypes = {
  tripId: PropTypes.string,
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
  bgClassName: PropTypes.string,
};

CheckInDateFilter.defaultProps = {
  tripId: undefined,
  doOpenDatePicker: false,
  setDoOpenDatePicker: () => { },
  bgClassName: undefined,
};

export default memo(CheckInDateFilter);
